import Module from 'mini-common-schema/lib/schema/Module';
import { attachPeopleCardRoutes } from 'mini-people-card-route-store';
import { ComposeSource } from 'mini-mail-compose-store/lib/store/schema/ComposeSource';
import { ComposeType } from 'mini-mail-compose-store/lib/store/schema/ComposeType';
import { getActiveReadingPanePath } from 'mini-mail-reading-pane-store/lib/utils/getActiveReadingPanePath';
import { getAttachmentPreviewSubRoute } from 'mini-preview-pane-store/lib/utils/getAttachmentPreviewSubRoute';
import { getComposeStore } from 'mini-mail-compose-store/lib/store/composeStore';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { getMailPath } from 'owa-url';
import { getMailRoutePath } from 'mini-mail-route-store/lib/utils/getMailRoutePath';
import { getStore as getFolderStore } from 'mini-mail-folder-store/lib/store/Store';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { getStore as getActivityPaneStore } from 'mini-activity-pane-store/lib/store/Store';

function getCurrentRoute(): string[] {
    const route = [];
    const { mailModule } = getMailStore();

    switch (mailModule.selectedModule) {
        case Module.Feedback:
            route.push('feedback');
            break;
        case Module.Options:
            // TODO A hack for navigating among subroutes of more than 2 levels
            // as of now only hierarchy of 2 so routes are getting skipped
            // will be refactored once react router migration is implemented.
            if (window.location.pathname.includes('storage')) {
                window.location.pathname
                    .replace(getMailPath(), '')
                    .split('/')
                    .forEach(path => route.push(decodeURIComponent(path)));
            } else {
                route.push('settings');
                mailModule.selectedSubRoute && route.push(mailModule.selectedSubRoute);
                mailModule.selectedSubRouteOption && route.push(mailModule.selectedSubRouteOption);
            }
            break;
        case Module.Search:
            if (window.location.pathname.indexOf('search') === -1) {
                route.push('search');
            } else {
                // In search module, any store changes trigger getCurrentRoute which then pushes /search route causing a redirect to search autosuggestion page
                // The below code ensures that the route change due to react-router is preserved and no new routes are pushed by getCurrentRoute.
                window.location.pathname
                    .replace(getMailPath(), '')
                    .split('/')
                    .forEach(path => route.push(decodeURIComponent(path)));
            }
            break;
        default:
            if (
                getActivityPaneStore().isActivityPaneOpen &&
                !getMailStore().mailModule.selectedId
            ) {
                route.push('activity');
                return route;
            }

            if (
                !getFolderStore().showMoveToFolderPane &&
                !getMailStore().mailModule.selectedId &&
                getListViewStore().shouldShowSearchBox
            ) {
                route.push('search');
                return route;
            }

            const composeStore = getComposeStore();

            if (
                composeStore.defaultViewState &&
                composeStore.defaultViewState.source === ComposeSource.Mail
            ) {
                switch (composeStore.defaultViewState.composeType) {
                    case ComposeType.FullCompose:
                        route.push('compose');
                        const viewState = composeStore.defaultViewState;
                        if (viewState && viewState.itemId && viewState.itemId.Id) {
                            route.push(viewState.itemId.Id);
                            route.push(...getAttachmentPreviewSubRoute());
                        }
                        return route;
                        break;
                    case ComposeType.QuickCompose:
                        window.location.pathname
                            .replace(getMailPath(), '')
                            .split('/')
                            .forEach(path => route.push(decodeURIComponent(path)));
                        return route;
                        break;

                    default:
                        break;
                }
            }

            // Add the route paths for generic mail route construction
            // return on match to avoid false positive match in getActiveReadingPanePath
            const mailRoutePath = getMailRoutePath();
            if (mailRoutePath.length) {
                return route.concat(mailRoutePath);
            }

            // Folder selection
            // Add the params for the regular path to open reading pane
            route.push(...getActiveReadingPanePath());

            break;
    }

    return route;
}

const getCalendarEventRoute = (baseGetCurrentRoute: () => string[]) => () => {
    // baseGetCurrentRoute is called always to make sure mobx store changes are always monitored
    let route = baseGetCurrentRoute();

    // Just return existing route when calendar event details are shown in Mail
    if (window.location.pathname.indexOf('/event/') > -1) {
        route = window.location.pathname
            .replace(getMailPath(), '')
            .split('/')
            .map(decodeURIComponent);
    }

    return route;
};

export default attachPeopleCardRoutes(getCalendarEventRoute(getCurrentRoute));
